import { render, staticRenderFns } from "./SubmitModal.vue?vue&type=template&id=56db542e&scoped=true&"
import script from "./SubmitModal.vue?vue&type=script&lang=js&"
export * from "./SubmitModal.vue?vue&type=script&lang=js&"
import style0 from "./SubmitModal.vue?vue&type=style&index=0&id=56db542e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56db542e",
  null
  
)

export default component.exports